/**
 * Object.values, only type safe!
 */
export function objectValues<T extends {}>(
  subject: T
): { [K in keyof T]: T[K] }[keyof T][] {
  return Object.values(subject) as { [K in keyof T]: T[K] }[keyof T][];
}
